module.exports = __webpack_public_path__ + "static/media/connect-logo-2.57fa265e.png";